// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"4d1eb940","488":"4fcd9421"}[chunkId] + ".chunk.js";
};